import { supabase } from './supabase';
export async function billingApi(path, body) {
  const { data } = supabase ? await supabase.auth.getSession() : { data: {} };
  const response = await fetch(path, { method: body === undefined ? 'GET' : 'POST', cache: 'no-store', headers: { 'Content-Type': 'application/json', ...(data.session ? { Authorization: `Bearer ${data.session.access_token}` } : {}) }, ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
  let result;
  try { result = await response.json(); } catch { throw new Error('El servicio no está disponible. Inténtalo más tarde.'); }
  if (!response.ok) { const error = new Error(result.error || 'No se pudo completar la operación.'); error.code = result.code; throw error; }
  return result;
}
export function getAiModel(feature = 'food_ai') {
  return { async generateContent(input) {
    const parts = typeof input === 'string' ? [{ text: input }] : input;
    const { text } = await billingApi('/api/gemini', { feature, parts });
    return { response: { text: () => text } };
  } };
}
